'use client'
import GoldLinkButton from '@/components/GoldLinkButton'
import { Link } from 'navigation'

const CitiesList = ({ citiesByCountry }) => {
  return (
    <section>
      <div className='container py-24'>
        <div className='flex flex-col gap-[72px]'>
          {Object.entries(citiesByCountry).map(([country, citiesArray]) => (
            <div
              key={country}
              className={`grid grid-cols-1 gap-y-6  md:grid-cols-12 ${
                citiesArray.length > 2 ? 'items-start' : 'items-center'
              }`}
            >
              <div className='col-span-4'>
                <h3 className='heading-common '>{country}</h3>
              </div>
              <div className='col-span-8'>
                <div className='grid grid-flow-row grid-cols-1 md:grid-cols-2 gap-y-4 md:gap-y-8 text-[18px] md:text-[16px]'>
                  {citiesArray.map((cityObj) => {
                    return cityObj.is_active &&
                      cityObj.url_link &&
                      cityObj.is_linked ? (
                      <Link
                        key={cityObj._id}
                        href={{
                          pathname: '/cities/[cityPage]',
                          params: { cityPage:  cityObj.url_link },
                        }}
                        className='font-light leading-[1.5] nav-link'
                      >
                        {cityObj.locality}
                      </Link>
                    ) : (
                      <p key={cityObj._id} className='font-light leading-[1.5]'>
                        {cityObj.locality}
                        </p>
                    )
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className='flex items-center justify-center py-24 pb-12'>
           <GoldLinkButton
                isNewTab
                href='https://business.rolzo.com/auth/login'
                hasGoldBackground
                text='Book now'
              />
        </div>
      </div>
    </section>
  )
}

export default CitiesList
